import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-waiver-dialog',
  templateUrl: './waiver-dialog.component.html',
  styleUrls: ['./waiver-dialog.component.css']
})
export class WaiverDialogComponent {

  waiver: string;

  constructor(
    public dialogRef: MatDialogRef<WaiverDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.waiver = data.waiver;
  }

  onNoClick(): void {
    this.data.partner.waiver = false;
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.data.partner.waiver = true;
    this.dialogRef.close();
  }
}
